var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:pt-6 lg:pt-0"},[_c('NormalHero',{attrs:{"data":_vm.page.header[0]}}),_vm._v(" "),_c('ComponentLoader',{attrs:{"components":_vm.page.content_block}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }